import { render, staticRenderFns } from "./AddSupplement.vue?vue&type=template&id=52d70ac2&scoped=true&"
import script from "./AddSupplement.vue?vue&type=script&lang=js&"
export * from "./AddSupplement.vue?vue&type=script&lang=js&"
import style0 from "./AddSupplement.vue?vue&type=style&index=0&id=52d70ac2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d70ac2",
  null
  
)

export default component.exports